module.exports = __webpack_public_path__ + "static/media/leque seletor.5cc0e99e.png";